<template>
  <div class="my-team-wrap">
    <div class="team-card">
      <div class="search-bar">
        <div class="data-type-wrap">
          <div @click="activeIndex = 0" :class="['item', { 'active': activeIndex == 0 }]">加入团体
          </div>
          <div v-if="hasTeam" @click="activeIndex = 1" :class="['item', { 'active': activeIndex == 1 }]">我的团队</div>
          <div v-if="createTeam" @click="activeIndex = 2" :class="['item', { 'active': activeIndex == 2 }]">创建团队</div>
        </div>
        <div class="search-inp-wrap" v-if="activeIndex == 0">
          <div class="inp-wrap">
            <input type="text" name="keyword" id="keyword" v-model="listQuery.keyword" placeholder="请输入团队名称/编号">
          </div>
          <div class="search-btn" @click="getAllTeamList">
            <img src="~@/assets/images/order_search_icon.png" alt="">
          </div>
        </div>
      </div>
      <div class="create-team-wrap" v-if="activeIndex == 2">
        <div class="title">创建团体尊享以下权益</div>
        <div class="list">
          <div class="item">
            <img src="~@/assets/images/team_create_icon1.png" alt="">
            <div class="title">团队开票管理</div>
            <div class="desc">统一给团体成员开票报销</div>
          </div>
          <div class="item">
            <img src="~@/assets/images/team_create_icon2.png" alt="">
            <div class="title">1500元现金券</div>
            <div class="desc">1500元团体专享优惠券</div>
          </div>
          <div class="item">
            <img src="~@/assets/images/team_create_icon3.png" alt="">
            <div class="title">超高额度先测后付</div>
            <div class="desc">1500元团体专享优惠券包</div>
          </div>
          <div class="item">
            <img src="~@/assets/images/team_create_icon4.png" alt="">
            <div class="title">便捷团队管理</div>
            <div class="desc">管理团队成员及团队订单</div>
            <!-- <div class="desc">管理团队成员并设置消费限额</div> -->
          </div>
          <div class="item">
            <img src="~@/assets/images/team_create_icon5.png" alt="">
            <div class="title">VIP团队管理</div>
            <div class="desc">成立VIP服务群，享受</div>
          </div>
          <div class="item">
            <img src="~@/assets/images/team_create_icon6.png" alt="">
            <div class="title">论文写作AI工具</div>
            <div class="desc">人工智能助您轻松写论文</div>
          </div>
          <div class="item">
            <img src="~@/assets/images/team_create_icon7.png" alt="">
            <div class="title">课题组网站</div>
            <div class="desc">免费创建课题组专属网站</div>
          </div>
        </div>
        <el-button class="create-btn flex-cc" @click="handleShowAddTeam">创建团体</el-button>
      </div>
      <div class="team-content">
        <template v-if="activeIndex == 0">
          <div class="apply-join-wrap" v-loading="loading">
            <div class="team-list" v-if="teamList.length > 0">
              <div v-for="(item, index) in teamList" :key="index" class="item" :class="{ 'active': item.id === teamId }"
                @click="handleCheck(item)">
                <div>团体编号：</div>
                <div>{{ item.no }}</div>
                <div>团体名称：</div>
                <div>{{ item.name }}</div>
                <div>所在高校/单位：</div>
                <div>{{ item.company }}</div>
                <div>团体负责人：</div>
                <div>{{ item.leader_name }}</div>
                <div>负责人电话：</div>
                <div>{{ item.leader_phone }}</div>
                <div>团体总成员：</div>
                <div>{{ item.user_count }}</div>
              </div>
            </div>
            <div v-else>
              <img class="empty-icon" src="~@/assets/images/team_empty.png" alt="">
            </div>
            <el-button v-if="teamId" class="apply-btn flex-cc" :loading="loading"
              @click="handleCheckJoin()">申请加入</el-button>
          </div>
        </template>
        <template v-if="activeIndex == 1">
          <div class="joined-team-wrap">
            <div class="card">
              <div class="item">
                <div>团体编号：</div>
                <div>{{ team.no }}</div>
                <div>团体名称：</div>
                <div>{{ team.name }}</div>
                <div>所在高校/单位：</div>
                <div>{{ team.company }}</div>
                <div>团体负责人：</div>
                <div>{{ team.leader_name }}</div>
                <div>负责人电话：</div>
                <div>{{ team.leader_phone }}</div>
                <div>团体总成员：</div>
                <div>{{ team.user_count }}</div>
                <template v-if="team.status == 2">
                  <div>驳回原因：</div>
                  <div class="colorRed">{{ team.reason }}</div>
                </template>
              </div>
              <div class="join-status">{{ team.status_name }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 未认证提示 -->
    <UnIdentity :visible.sync="showUnIdentityForm" />
    <!-- 创建团队 -->
    <AddTeam :visible.sync="showAddTeamForm" :hasTeam="hasTeam" @success="handleAddTeamSuccess" />
  </div>
</template>

<script>
import { getIndex, getTeamIndex, getAllTeamList, applyTeam } from "@/api/user";
import UnIdentity from '@/components/unIdentity';
import AddTeam from './components/addTeam';
import { mapGetters } from "vuex";
export default {
  name: 'UserTeam',
  components: {
    UnIdentity,
    AddTeam
  },
  data() {
    return {
      loading: true,
      activeIndex: 0,
      showUnIdentityForm: false,
      showAddTeamForm: false,
      listQuery: {
        keyword: null,
      },
      team: {},
      user: {},
      teamId: 0,
      teamList: [],
    };
  },
  watch: {
    activeIndex(value) {
      // this.resetForm()
      // this.getTeamIndex();
    }
  },
  computed: {
    ...mapGetters(["phone"]),
    hasTeam() {
      return Object.keys(this.team).length > 0;
    },
    createTeam() {
      return (this.team.user_id != this.user.id) || (this.team.status == 2);
    },
  },
  created() {
    this.getUserIndex()
    this.getTeamIndex();
  },
  methods: {
    handleAddTeamSuccess() {
      this.getUserIndex();
      this.getTeamIndex();
    },
    getUserIndex() {
      getIndex({}).then(res => {
        this.loading = false;
        this.user = res.data.user;
      }).catch((err) => {

      });
    },
    getTeamIndex() {
      getTeamIndex({}).then(res => {
        this.loading = false;
        this.team = res.data.team || {};
        this.activeIndex = res.data.active;
      }).catch((err) => {

      });
    },
    // 获取列表
    getAllTeamList() {
      const _listQuery = Object.assign({}, this.listQuery);
      if (!_listQuery.keyword) {
        this.$message.error('请输入关键词');
        return;
      }
      this.loading = true;
      getAllTeamList(_listQuery)
        .then((response) => {
          this.loading = false;
          if (response.data.length == 0) {
            this.$message.error('未找到符合条件的团队');
            return;
          }
          this.teamList = response.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCheck(item) {
      this.teamId = item.id;
    },
    handleCheckJoin() {
      if (!this.teamId) {
        this.$message.error('请选择所要申请的团队');
        return;
      }
      if (this.hasTeam) {
        this.$confirm('您已经在其他团队，如继续加入将会自动离开原团队?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.handleJoinTeam();
        });
      } else {
        this.handleJoinTeam();
      }
    },
    handleJoinTeam() {
      this.loading = true;
      applyTeam({ id: this.teamId }).then(res => {
        this.resetForm();
        this.handleAddTeamSuccess()
        this.$message.success('申请成功,请等待团长审核!');
      }).catch(() => {
        this.loading = false;
      });
    },
    resetForm() {
      this.loading = false;
      this.teamId = 0;
      this.teamList = [];
      this.listQuery = {
        keyword: null,
      };
    },
    handleShowAddTeam() {
      this.showAddTeamForm = true
    }

  }
};
</script>

<style lang="scss" scoped>
.my-team-wrap {
  width: 100%;
  margin-top: 16px;

  .team-card {
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px 2px 2px 2px;

    .search-bar {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 21px 29px 21px 31px;
      box-sizing: border-box;
      border-bottom: 1px solid #CCD7DB;

      .search-inp-wrap {
        box-shadow: 0px 12px 19px 1px rgba(60, 128, 209, 0.0863);
        border: 1px solid #CCD7DB;
        display: flex;
        align-items: center;

        .inp-wrap {
          width: 367px;
          height: 40px;
          padding: 0 22px;
          display: flex;
          align-items: center;

          &>input {
            width: 100%;
            border: none;
            outline: none;
            background-color: transparent;
          }
        }

        .search-btn {
          width: 65px;
          height: 40px;
          background: #6F7F84;
          box-shadow: 0px 12px 19px 1px rgba(60, 128, 209, 0.0863);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }

      .data-type-wrap {
        display: flex;
        align-items: center;
        column-gap: 20px;

        .active {
          color: #FFFFFF !important;
          background: #00B4E8 !important;
        }

        .item {
          font-size: 16px;
          font-weight: 400;
          color: #00B4E8;
          background: #00b6e81a;
          padding: 7px 35px;
          cursor: pointer;
        }
      }
    }

    .create-team-wrap {
      width: 100%;
      padding-top: 33px;
      background-color: #FFFFFF;
      min-height: 736px;
      padding-bottom: 50px;
      box-sizing: border-box;

      &>.title {
        font-size: 16px;
        font-weight: bold;
        color: #222222;
        text-align: center;
      }

      .list {
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 46px;
        row-gap: 43px;
        margin-top: 35px;
        flex-wrap: wrap;

        .item {
          display: flex;
          align-items: center;
          flex-direction: column;
          row-gap: 18px;

          &>.title {
            font-size: 20px;
            font-weight: blod;
            color: #222222;
          }

          &>.desc {
            font-size: 16px;
            font-weight: 300;
            color: #222222;
          }
        }
      }

      .create-btn {
        width: 200px;
        height: 40px;
        background: #00B4E8;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 300;
        color: #FFFFFF;
        margin: 43px auto 0 auto;
        cursor: pointer;
      }
    }

    .team-content {
      width: 100%;
      min-height: 736px;
      padding-bottom: 50px;

      .empty-icon {
        display: block;
        margin: 56px auto 0 auto;
      }

      .joined-team-wrap {
        width: 100%;
        padding: 21px 30px 0 30px;
        display: flex;
        align-items: center;
        flex-direction: column;
        row-gap: 20px;
        box-sizing: border-box;

        .card {
          width: 100%;
          padding: 16px 62px 16px 31px;
          background: #F4F8F9;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: 618px 60px;
          align-items: center;
          justify-content: space-between;

          .item {
            font-size: 16px;
            font-weight: 300;
            color: #222222;
            display: grid;
            grid-template-columns: 120px auto;
            column-gap: 50px;
            row-gap: 12px;
            align-items: center;
          }

          .join-status {
            font-size: 20px;
            font-weight: 400;
            color: #6F7F84;
          }
        }
      }

      .apply-join-wrap {
        .team-list {
          display: flex;
          align-items: center;
          flex-direction: column;
          width: 722px;
          margin: 51px auto 0 auto;
          row-gap: 20px;

          .item {
            width: 100%;
            padding: 37px 42px;
            box-sizing: border-box;
            background: #F4F8F9;
            font-size: 16px;
            font-weight: 300;
            color: #222222;
            display: grid;
            grid-template-columns: 120px auto;
            column-gap: 50px;
            row-gap: 12px;
            align-items: center;
            cursor: pointer;
          }

          .active {
            border: 1px solid #00B4E8 !important;
          }
        }

        .apply-btn {
          width: 200px;
          height: 40px;
          background: #00B4E8;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 300;
          color: #FFFFFF;
          margin: 31px auto 0 auto;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
